import { Button, FormControl, InputLabel, Link, MenuItem, Select, Typography } from '@mui/material';
import * as React from 'react';
import { useHistory } from 'react-router';
import Text from '../../../shared/Text';
import { LOGIN_INDEX } from '../../constants/routes';
import FormValidationMessage from '../form-validation-message';
import LoginWrapper from '../login-wrapper';
import { SsoLoginUrl } from '../providers/auth/context';
import { useAuthData } from '../providers/auth/hooks';
import { FormFieldWrapper, FormSubmitWrapper, FormWrapper } from '../shared-form-components';

const Sso: React.FC = () => {
  const [currentSsoLoginUrl, setCurrentSsoLoginUrl] = React.useState<SsoLoginUrl>();

  const history = useHistory();
  const { ssoLoginUrls } = useAuthData();

  const login = (ssoLoginUrl: SsoLoginUrl) => {
    window.location.assign(ssoLoginUrl.loginUrl);
  };

  React.useEffect(() => {
    if (ssoLoginUrls?.length === 1) {
      login(ssoLoginUrls[0]);
    } else if (!ssoLoginUrls?.length) {
      history.push(LOGIN_INDEX);
    }
  }, [ssoLoginUrls]);

  // build menu items and find current selected index
  const idpMenuItems = ssoLoginUrls?.map((idp, index) => {
    return {
      payload: index.toString(), // These don't have ids but also won't change while viewing the page so just use the index as the id
      text: idp.displayName,
    };
  });

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    login(currentSsoLoginUrl);
  };

  const changeProviderHandler: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    setCurrentSsoLoginUrl(ssoLoginUrls[Number.parseInt(event.target.value, 10)]);
  };

  return (
    <LoginWrapper showSupportLink>
      <FormWrapper>
        <form name="ssoFrm" noValidate>
          {/* No validation but leaving this here for blank space so all pages look consistent */}
          <FormValidationMessage message={null} />

          <FormFieldWrapper>
            <Typography>{Text.get('sso_title')}</Typography>
          </FormFieldWrapper>

          <FormFieldWrapper>
            <FormControl fullWidth>
              <InputLabel id="provider-label">Select provider</InputLabel>
              <Select
                data-test="sso-form-provider-dropdown"
                fullWidth
                label="Select provider"
                labelId="provider-label"
                onChange={changeProviderHandler}
                value={ssoLoginUrls?.indexOf(currentSsoLoginUrl)?.toString() || ''}
              >
                {idpMenuItems?.map((item) => (
                  <MenuItem key={item.payload} value={item.payload}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </FormFieldWrapper>

          <FormSubmitWrapper>
            <Button
              data-test="submit"
              disabled={!currentSsoLoginUrl}
              name="submit"
              onClick={submitHandler}
              type="submit"
              variant="contained"
            >
              {Text.get('_button_continue')}
            </Button>
          </FormSubmitWrapper>

          <FormFieldWrapper>
            <Link href={`#${LOGIN_INDEX}`}>{Text.get('sso_signin_different_account')}</Link>
          </FormFieldWrapper>
        </form>
      </FormWrapper>
    </LoginWrapper>
  );
};

export default Sso;
